import ApiService from "./ApiService"
import appConfig from '../configs/app.config'

export async function getPoolList (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getforms',
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        params: {
            start_date: data.start_date,
            end_date: data.end_date,
            customer_type: data.customer_type,
            report_type: data.report_type
        }
    })
}

// form_type_names gönderdiğinde
/*
{
    "Status": "Normal",
    "Content": {
        "1": "MAĞAZA",
        "2": "İSTASYON",
        "3": "DİĞER"
    }
}
buradaki customer type seçimlerini getPoolList göndereceğiz.
*/
export async function getEnumData (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getenumdata',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data: {
            enum_data_type: data.enum_data_type
        }
    })
}

export async function getBulunurlukReports (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'availabilityreport',
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        params: {
            start_date: data.start_date,
            end_date: data.end_date
        }
    })
}
export async function getVisitsReports (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'visitreport',
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        params: {
            start_date: data.start_date,
            end_date: data.end_date
        }
    })
}

export async function getReports (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'mobreportnew',
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

// DSA resimleri çekilenler
export async function getDsaResultReport (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getdsaresultsnew?date='+data.date+'&type='+data.type,
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        data
    })
}

// Dolap resimleri çekilenler
export async function getPicosResultReport (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getpicosresultsnew?date='+data.date+'&type='+data.type,
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        data
    })
}

// Dolap resimleri çekilenler
export async function getPicosResultReportAll (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getpicosallresultsnew?date='+data.date+'&type='+data.type,
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        data
    })
}

// Dolap resimleri çekilenler
export async function getPivotRafPayiResultReport (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getshelfshareresultsnew?date='+data.date+'&type='+data.type,
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        data
    })
}

// Dolap resimleri çekilenler
export async function getDisplayResultNew (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getdisplayresultsnew?date='+data.date+'&type='+data.type,
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        data
    })
}

// Dolap resimleri çekilenler
export async function getWatersBulunurluk (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getwatersavailabilityreport?date='+data.date+'&type='+data.type,
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        data
    })
}


// Temsilci Ziyaret İstatistiklerini döndürür
export async function getTransactionsSSM (data) {
    return ApiService.fetchData({
        url: 'https://labeldnn.neocortexs.com/servis',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

// KPI Skorları döndürür
export async function getKpiScoreVisits (data) {
    return ApiService.fetchData({
        url: 'https://labeldnn.neocortexs.com/servis',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

// Genel Raporları Döndürür
export async function getGeneralReports (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'mobreport',
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        data
    })
    /*
    return ApiService.fetchData({
        url: 'https://labelge.neocortexs.com/servis',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
    */
}

// Genel Servis istekleri için kullanılır
export async function getVariableService (data) {
    return ApiService.fetchData({
        url: 'https://labeldnn.neocortexs.com/servis',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

export async function getKPIscoreTrends (params) {
    return ApiService.fetchData({
        url: '/stats/kpi_trends',
        method: 'get',
        params
    })
}


export async function getKPIscorePer (params) {
    return ApiService.fetchData({
        url: '/stats/kpi_per',
        method: 'get',
        params
    })
}